import BrandMark from '../BrandMark';

const Footer = () => (
  <footer style={{ padding: '56px clamp(20px, 5vw, 48px) 32px', borderTop: '1px solid #e0e0e0', background: '#0C3540', color: 'rgba(255,255,255,0.55)' }}>
    <div style={{ maxWidth: 1080, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 40, paddingBottom: 36, borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, color: '#fff', fontFamily: "'DM Serif Display',serif", fontWeight: 600, fontSize: 17 }}>
          <BrandMark size={26} />
          NTHRA LABS
        </div>
        <div style={{ display: 'flex', gap: 44, flexWrap: 'wrap' }}>
          <div>
            <h4 style={{ fontFamily: "'Space Mono',monospace", fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'rgba(255,255,255,0.4)', marginBottom: 14 }}>Product</h4>
            <a href="/digital-material-passport" style={{ display: 'block', fontSize: 14, marginBottom: 10, color: 'rgba(255,255,255,0.65)' }}>Digital Material Passport</a>
            <a href="/technology" style={{ display: 'block', fontSize: 14, marginBottom: 10, color: 'rgba(255,255,255,0.65)' }}>Technology</a>
            <a href="/industries" style={{ display: 'block', fontSize: 14, marginBottom: 10, color: 'rgba(255,255,255,0.65)' }}>Industries</a>
            <a href="https://blog.nthralabs.com" target="_blank" rel="noopener noreferrer" style={{ display: 'block', fontSize: 14, marginBottom: 10, color: 'rgba(255,255,255,0.65)' }}>Blog</a>
          </div>
          <div>
            <h4 style={{ fontFamily: "'Space Mono',monospace", fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'rgba(255,255,255,0.4)', marginBottom: 14 }}>Company</h4>
            <a href="/team" style={{ display: 'block', fontSize: 14, marginBottom: 10, color: 'rgba(255,255,255,0.65)' }}>Team</a>
            <span style={{ display: 'block', fontSize: 14, marginBottom: 10, color: 'rgba(255,255,255,0.65)' }}>Bangalore, India</span>
            <a href="mailto:support@nthralabs.com" style={{ display: 'block', fontSize: 14, marginBottom: 10, color: 'rgba(255,255,255,0.65)' }}>support@nthralabs.com</a>
          </div>
        </div>
      </div>
      <div style={{ paddingTop: 26, display: 'flex', justifyContent: 'space-between', fontSize: 12.5, flexWrap: 'wrap', gap: 10 }}>
        <span>© 2026 Nthra Labs. </span>
        
      </div>
      <div style={{ color: 'rgba(255,255,255,0.35)', fontSize: 11, textAlign: 'center', lineHeight: 1.6, marginTop: 20 }}>
        Nthra Labs Private Limited, 178, 5th Main, 1st Stage, Indiranagar, Binnamangala, Indiranagar (Bangalore), Bangalore, Karnataka, India, 560038
      </div>
    </div>
  </footer>
);

export default Footer;
